import { _ } from "libs";

import React, { Component } from "react";
import { Form, Field } from "react-final-form";
import { Link, NavLink } from "react-router-dom";
import { FORM_ERROR } from "final-form";
import withRedux from "../withRedux";
import { login, socialLogin } from "../actions";
import FacebookLogin from "./facebookLogin";
import GoogleLogin from "./googleLogin";
import { HttpError } from "libs";
import { APIError } from "../types";

const validate = (values: object) => {
	return {};
};

type Props = {
	login: any;
	socialLogin: any;
	destination?: string;
};

class LoginForm extends Component<Props> {
	onSubmit = async ({ email, password }) => {
		try {
			await this.props.login(email, password, this.props.destination);
		} catch (err) {
			if (err instanceof HttpError) {
				const data = await err.json<APIError>();
				return { [FORM_ERROR]: data.error_description };
			}

			return { [FORM_ERROR]: err.message };
		}
	};

	onSocialLogin = (type, token) => {
		this.props.socialLogin(type, token, this.props.destination);
	};

	render() {
		return (
			<div className="auth-form login-form">
				<div>
					<Form
						onSubmit={this.onSubmit}
						validate={validate}
						render={({ submitError, handleSubmit, submitting, pristine, invalid, values }) => (
							<form onSubmit={handleSubmit} className="form-signin lite">
								{submitError && <div className="alert error">{submitError}</div>}
								<Field name="email">
									{({ input, meta }) => (
										<div className="field size_m">
											<label htmlFor="username">{_("loginForm.emailOrUsername.label")}</label>
											<input type="text" {...input} id="username" />
											{meta.touched && meta.error && <span>{meta.error}</span>}
										</div>
									)}
								</Field>
								<Field name="password">
									{({ input, meta }) => (
										<div className="field size_m">
											<label htmlFor="field_password">{_("loginForm.password.label")}</label>
											<input
												type="password"
												{...input}
												//placeholder={_("loginForm.password.placeholder")} //empty according to the design
												id="password"
											/>
											{meta.touched && meta.error && <span>{meta.error}</span>}
										</div>
									)}
								</Field>
								<div className="password_actions">
									{/*
									<Field name="remember_me">
										{({ input, meta }) => (
											<div className="field checkbox">
												<input type="checkbox" {...input} id="field_remember_me" />
												<label htmlFor="field_remember_me">Remember me</label>
											</div>
										)}
									</Field>
										*/}
									<div className="password_reset">
										<a
											className="plain"
											href={process.env.REACT_APP_LEGACY_LOGIN + "#reset"}
											target="_blank"
											rel="noopener noreferrer"
										>
											{_("loginForm.passwordReset.label")}
										</a>
									</div>
								</div>
								<button
									id="id-login"
									className="button submit"
									type="submit"
									disabled={submitting || pristine}
								>
									{_("loginForm.submitButton.label")}
								</button>
							</form>
						)}
					/>
					<div className="social_login">
						{_("loginForm.socialLogin.text")}&nbsp;
						<FacebookLogin
							appId={process.env.REACT_APP_FB_APP_ID}
							onLogin={(token) => this.onSocialLogin("_facebook", token)}
						/>
						&nbsp;/&nbsp;
						<GoogleLogin
							appId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
							onLogin={(token) => this.onSocialLogin("_google", token)}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default withRedux({ login, socialLogin })(LoginForm);
